import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useProducts() {
  const [products, setProducts] = useState(cache || []);
  const reload = useCallback(async () => {
    const { data } = await api.get("/products").catch(() => ({ data: [] }));
    cache = data;
    setProducts(data);
  }, []);
  useEffect(() => {
    if (!cache) reload();
    window.addEventListener("products:changed", reload);
    return () => window.removeEventListener("products:changed", reload);
  }, [reload]);
  return { products, reload };
}

export function useLoad(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchRef = useRef(fetcher);
  fetchRef.current = fetcher;
  const key = JSON.stringify(deps);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await fetchRef.current());
    } finally {
      setLoading(false);
    }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    load();
    window.addEventListener("stock:changed", load);
    return () => window.removeEventListener("stock:changed", load);
  }, [load]);
  return { data, loading, reload: load, setData };
}
